<template lang="pug">
v-menu(
  v-model="menu",
  :close-on-content-click="false"
  offset-y,
  tile,
)
  template(v-slot:activator="{ on, attrs }")
    g-btn(icon, v-bind="attrs", v-on="on")
      v-badge(dot, :content="hasUnreadComments", :value="hasUnreadComments", color="red")
        v-icon.primary--text mdi-message-text
  comments-card(
    @hide="menu = false",
    @reload="loadComments",
    @more="more",
    @markAll="markAll"
    v-bind="{ tags, loading }",
  )
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    menu: false,
    tags: [],
    sizeIndex: 0,
    pageSizes: [5, 10, 15, 25, 50, -1],
    loading: true,
    hasUnreadComments: false,
    locationsToForceCommentsLoad: ['home', 'order.index', 'shipment.index']
  }),
  watch: {
    menu(val) {
      if (val) this.loadComments();
    },
    '$route.name':
    {
      handler:function(routeName)
      {
        if(this.locationsToForceCommentsLoad.includes(routeName))
        {
            this.checkComments();
        }
      },

    }
  },
  methods: {
    async markAll() {
      if (!this.tags.length) return;

      try {
        this.loading = true;
        const uids = this.tags.map(x => x.uid);
        await axios.post('user/MarkReadMyComments', { uids });
        await this.loadComments();
      } catch(e) {
        console.log(this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
    more() {
      if (this.sizeIndex < this.pageSizes.length - 1) this.sizeIndex += 1;
      this.loadComments();
    },
    async loadComments() {
      try {
        this.loading = true;
        this.hasUnreadComments = false;
        let endpoint = this.$fetchLoad("Tags", true, "Comment.User", "Comment.Order", "Comment.Shipment");
        const whereTags = ["y => y.userId == " + this.$store.state.user.user.id, "x => !x.isRead"];
        this.tags = (
          await axios.get(endpoint, { params: { pageSize: this.pageSizes[this.sizeIndex], where: whereTags } })
        ).data.data;
        if(this.tags.length > 0) this.hasUnreadComments = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async checkComments() {
      try{
        let endpoint = this.$fetchLoad("Comments", true);

        let unreadTagsCount = (
          await axios.get(endpoint + "/GetUnreadTagsCount")
        ).data;

        if(unreadTagsCount > 0) this.hasUnreadComments = true;
        else this.hasUnreadComments = false;
      }
      catch(error)
      {
        console.error(error);
      }
    },
  },
}
</script>
